// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cfmk","title":"InfoRow_title__pgtdf"};